$(document).ready(function(){
    if($('.shopify-section--blog-posts').length){
      $('.article-item').each(function(){
        var foreignCharacters = $(this).find('h3.article-item__title.heading.h5 a').text();
        var rforeign = /[\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf]/;
        if (!rforeign.test(foreignCharacters)) {
          var $jpText = '<span class="u-enText">'+ foreignCharacters +'</span>';
          $(this).find("h3.article-item__title.heading.h5 a").html($jpText);
        }
      })

      var checkInstagram = setInterval(function() {
        var $item = $('#insta-feed h2');
        if ($item.length) {
          clearInterval(checkInstagram);
          $item.addClass('c-instagram container');

          if($(window).width() >= 769){
            $item.prepend('<div class="c-instagram__follow is-hide-mobile"><a href="https://www.instagram.com/houbidou.jp/" class="c__btn" target="_blank">@houbidou.jp</a></div>');
          } else {
            $('#insta-feed').append('<div class="c-instagram__follow is-hide-desktop"><a href="https://www.instagram.com/houbidou.jp/" class="c__btn" target="_blank">@houbidou.jp</a></div>');
          }

          $(window).on('resize', function() {
            if($(window).width() >= 769){
              if ($('.c-instagram__follow.is-hide-mobile').length < 0){
                $item.prepend('<div class="c-instagram__follow is-hide-mobile"><a href="https://www.instagram.com/houbidou.jp/" class="c__btn" target="_blank">@houbidou.jp</a></div>');
              }
            } else {
              if ($('.c-instagram__follow.is-hide-desktop').length < 0){
                $('#insta-feed').append('<div class="c-instagram__follow is-hide-desktop"><a href="https://www.instagram.com/houbidou.jp/" class="c__btn" target="_blank">@houbidou.jp</a></div>');
              }
            }
          });

          $item.append('<br><span class="c-heading-jp">インスタグラム</span>');

          // setTimeout(function(){
          //     $('#insta-feed').prepend('<div class="c-instagram__follow"><a href="" class="c__btn" target="_blank">@houbidou.jp</a></div>');
          // },3000);
        }
      }, 100); // check every 100ms
    }

// 	BEGIN MODAL PRODUCT DETAIL
    $('.link-map-modal').click(function(){
      if ($('body').hasClass('template-product')){
        if($('.shopify-section--store-location').not('.is-show-modal')){
          $('.shopify-section--store-location').addClass('is-show-modal');
        }
      } 
//       else if ($('body').hasClass('template-index')){
//         var self = $(this);
        
//         $('.toppage-map').each(function(){
//           if(self.attr('data-store-id') == $(this).attr('data-store-id') && $(this).not('.is-show-modal')){
//             $(this).addClass('is-show-modal');
//           }
//         });
//       }
      
      $('body').addClass('overflow-hidden');
    })
    
     $('.shopify-section--store-location .icon--close').click(function(){
      if ($('body').hasClass('template-product')){
        $('.shopify-section--store-location').removeClass('is-show-modal');
      } 
//        else if ($('body').hasClass('template-index')){
//         var self = $(this).parents('.toppage-map').attr('data-store-id');
        
//         $('.toppage-map').each(function(){
//           if(self == $(this).attr('data-store-id')){
//             $(this).removeClass('is-show-modal');
//           }
//         });
//       }
       
       $('body').removeClass('overflow-hidden');
    })
     
     
     $('.store-location__overlay').click(function(){
       if ($('body').hasClass('template-product')){
         $('.shopify-section--store-location').removeClass('is-show-modal');
       } 
//        else if ($('body').hasClass('template-index')){
//         var self = $(this).parents('.toppage-map').attr('data-store-id');
        
//         $('.toppage-map').each(function(){
//           if(self == $(this).attr('data-store-id')){
//             $(this).removeClass('is-show-modal');
//           }
//         });
//        }
       
       $('body').removeClass('overflow-hidden');
    })

   
  // 	END MODAL PRODUCT DETAIL
      
      //custom recommendations
   var recommendations = setInterval((function() {
          $(".rktheme-product-price-wrap").length && (clearInterval(recommendations),
          setTimeout((function() {
              $(".rktheme-product-price-wrap .rktheme-product-price.rktheme-product-price--compare").append('<span class="c-tax"> (税込)</span>'),
              $(".rktheme-product-price-wrap .rktheme-product-price.rktheme-product-price--original").append('<span class="c-tax"> (税込)</span>')
              $(".rktheme-widget-title").after('<h2 class="rktheme-widget-subtitle">おすすめ商品</h2>')
//               $(".rktheme-product-title").after('<span class="rktheme-product-rank">ランク: A</span>')    
              $(".rktheme-widget-container").append('<a href="/collections/recommend" class="rktheme-widget-link">すべての商品を見る</a>')            

          }), 200)) 
          
          
      }
   ), 100);
  
//   change text shop now   
  var textShopNow = setInterval(function() {
    if ($('.shopify-payment-button__button').length){
      clearInterval(textShopNow);
      if($('.shopify-payment-button__button').attr('data-testid') == 'Checkout-button'){
      $('.shopify-payment-button__button').text('今すぐ購入する');
        $('.shopify-payment-button__button').css('opacity','1');
      console.log($('.shopify-payment-button__button').attr('data-testid'));
      }
//       if ($('.shopify-payment-button__button').html().indexOf('今すぐ購入する') != -1)  
    };
  },2000);

  })